import * as DSAssetFamilies from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { HUBSPOT_DEFINED } from '../../../filterQueryFormat/associations/AssociationCategory';
import { AdapterCache } from '../../requestCaches/adaptersCache';
import { Map as ImmutableMap, Seq } from 'immutable';
import Adapter from './Adapter';
import AssociationRecord from 'customer-data-objects/associations/AssociationRecord';
import PortalIdParser from 'PortalIdParser';
import http from 'hub-http/clients/apiClient';
const ASSOCIATIONS_BLOCKLIST = new Set([31, 32, 57, 58, 59, 60, 61, 62]);
export const isExcludedAssociation = (id, category) => {
  return category === HUBSPOT_DEFINED && ASSOCIATIONS_BLOCKLIST.has(id);
};
const formatAssociationDefinitions = associationDefinitions => {
  return associationDefinitions === null || associationDefinitions === void 0 ? void 0 : associationDefinitions.reduce((acc, associationDefinition) => {
    const {
      cardinality,
      category,
      fromObjectType,
      fromObjectTypeId,
      hasAllAssociatedObjects,
      id,
      inverseId,
      inverseLabel,
      isInversePrimary,
      isPrimary,
      label,
      maxToObjectIds,
      name,
      toObjectType,
      toObjectTypeId
    } = associationDefinition;
    if (isExcludedAssociation(id, category)) {
      return acc;
    }
    const associationRecord = AssociationRecord({
      cardinality,
      category,
      // @ts-expect-error AssociationRecord missing possible object type "OWNER"
      fromObjectType,
      fromObjectTypeId,
      hasAllAssociatedObjects,
      id,
      inverseId,
      inverseLabel,
      isInversePrimary,
      isPrimary,
      label,
      maxToObjectIds,
      name,
      // @ts-expect-error AssociationRecord missing possible object type "OWNER"
      toObjectType,
      toObjectTypeId
    });
    const prevFormattedAssociationRecords = acc.get(toObjectTypeId) || ImmutableMap();
    const newFormattedAssociationRecords = prevFormattedAssociationRecords.set(`${name}__${id}`, associationRecord);
    return acc.set(toObjectTypeId, newFormattedAssociationRecords);
  }, ImmutableMap());
};
export class AssociationDefinitionsAdapterConfig {
  constructor() {
    this.associationDefinitionsCache = new AdapterCache();
  }
  isAssetFamilySupported(assetFamily) {
    return assetFamily === DSAssetFamilies.ASSOCIATION_DEFINITION;
  }
  getFetcher() {
    return http.get;
  }
  fetchData(httpClient, __assetFamily, variables) {
    const {
      ids: objectTypeIds
    } = variables;
    if (!objectTypeIds) {
      return Promise.resolve([]);
    }
    const options = {
      query: {
        portalId: PortalIdParser.get(),
        includeFATypes: true
      }
    };
    const requests = objectTypeIds.map(id => {
      const cachedAssociationDefinitions = this.associationDefinitionsCache.get(id);
      if (cachedAssociationDefinitions) {
        return cachedAssociationDefinitions;
      }
      const associationDefinitions = httpClient(`associations/v1/definitions/${id}`, options);
      this.associationDefinitionsCache.set(id, associationDefinitions);
      return associationDefinitions;
    });
    return Promise.all(requests).then(associationDefinitions => {
      return objectTypeIds.map((id, index) => [id, associationDefinitions[index]]);
    });
  }
  formatData(associationDefinitions) {
    return Seq.Keyed(associationDefinitions).map(formatAssociationDefinitions).toMap();
  }
  clearCache(objectTypeId) {
    this.associationDefinitionsCache.clear(objectTypeId);
  }
  clearCacheAll() {
    this.associationDefinitionsCache.clearAll();
  }
}
export default Adapter.makeFromConfig(AssociationDefinitionsAdapterConfig);